import React from 'react';
import createFragment from 'react-addons-create-fragment';
import { View } from '@dbk/ui-react-utils';
import { propTypes, defaultProps } from './common';
import PopoverContentContainer from './popover-content-container/popover-content-container';
import getClassNames from './popover-inline.styles';

class PopoverInline extends React.Component {
  static propTypes = propTypes;
  static defaultProps = defaultProps;
  constructor() {
    super();
    this.state = {
      closing: false,
    };
  }
  hide = () => {
    this.setState({
      closing: true,
    });
  };

  render() {
    const {
      children,
      content,
      displayBlock,
      id,
      className,
      ...rest
    } = this.props;
    const popover = (
      <PopoverContentContainer
        mode="inline"
        onMouseLeave={this.hide}
        onHide={this.hide}
        closing={this.state.closing}
        id={id}
        {...rest}
      >
        {content}
      </PopoverContentContainer>
    );
    const { orientation } = rest;
    const classes = getClassNames(orientation, displayBlock, className);
    return (
      <View id={id} className={classes}>
        {orientation === 'top' || orientation === 'left'
          ? createFragment({ popover, children })
          : createFragment({ children, popover })}
      </View>
    );
  }
}

export default PopoverInline;
